import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbLoginFormComponent } from './ab-login-form.component';

@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule
    ],
    declarations: [
        AbLoginFormComponent
    ],
    entryComponents: [
        AbLoginFormComponent
    ],
    exports: [
        AbLoginFormComponent
    ]
})
export class AbLoginFormModule  { }
